// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"310efc6d","453":"f281f175","667":"a571c18b"}[chunkId] + ".chunk.js";
};